import { browserPlantGardenV2Repository } from './BrowserPlantGardenV2Adapter'
import { HttpPlantGardenV2Adapter, type HttpPlantGardenV2AdapterOptions } from './HttpPlantGardenV2Adapter'
import type { PlantGardenV2Repository } from './PlantGardenV2Repository'

export type PlantGardenV2PersistenceMode = 'browser' | 'mysql'

export interface CreatePlantGardenV2RepositoryOptions {
  mode?: PlantGardenV2PersistenceMode
  http?: HttpPlantGardenV2AdapterOptions
  browserRepository?: PlantGardenV2Repository
}

export function readPlantGardenV2PersistenceMode(
  value = import.meta.env?.VITE_OPENELP_WORKSPACE_MODE,
): PlantGardenV2PersistenceMode {
  const mode = value?.trim() || 'browser'
  if (mode !== 'browser' && mode !== 'mysql') throw new Error(`Unsupported VITE_OPENELP_WORKSPACE_MODE: ${mode}`)
  return mode
}

export function createPlantGardenV2Repository(
  options: CreatePlantGardenV2RepositoryOptions = {},
): PlantGardenV2Repository {
  const mode = options.mode ?? readPlantGardenV2PersistenceMode()
  if (mode === 'mysql') return new HttpPlantGardenV2Adapter(options.http)
  return options.browserRepository ?? browserPlantGardenV2Repository
}
